<template>
    <div class="warehouse-edit__wrapper">
        <form @submit.prevent="onSubmit" @reset.prevent="onReset" class="app__card_edit warehouse-edit">
            <div class="app__card-header warehouse-edit__card-header">{{ warehouseEditTitle }}</div>
            <div class="app__card-body_edit">
                <sah-input
                    :label="$tc('warehouses.name')"
                    v-model="warehouseModel.name"
                    :required="true"
                    :placeholder="$tph(`applicationsFields.placeholders.warehouse.name`)"
                ></sah-input>
                <sah-input
                    :label="$tc('warehouses.creationDate')"
                    v-model="warehouseModel.creationDate"
                    type="date"
                ></sah-input>
                <sah-input :label="$tc('warehouses.contactName')" v-model="warehouseModel.contactName"></sah-input>
                <sah-input
                    :label="$tc('warehouses.contactEmail')"
                    v-model="warehouseModel.contactEmail"
                    type="email"
                ></sah-input>
                <sah-input
                    v-for="(link, index) in warehouseModel.links"
                    :key="link.key"
                    :label="$tc(`warehouses.${link.key}`)"
                    v-model="warehouseModel.links[index].url"
                    :placeholder="$tph(`applicationsFields.placeholders.warehouse.url`)"
                ></sah-input>
            </div>
            <div class="app__card-footer">
                <sah-button class="app__button_alt" type="reset">{{ $tc("words.cancel") }}</sah-button>
                <sah-button type="submit">{{ $tc("words.save") }}</sah-button>
            </div>
        </form>
    </div>
</template>

<script>
import {store, SahInput, SahButton} from "atom";
const {createNamespacedHelpers} = store;
const {mapActions} = createNamespacedHelpers("arcman");
/**
 *
 * @vue-prop {Object} warehouse - warehouse
 */
export default {
    name: "warehouse-edit",
    components: {
        SahInput,
        SahButton,
    },
    props: {
        operation: {type: String, required: true},
        warehouse: {type: Object, required: true},
    },
    computed: {
        warehouseEditTitle() {
            return this.operation === "store"
                ? this.$tc("warehouses.createWarehouse")
                : `${this.$tc("words.edit")} ${this.warehouseModel.name}`;
        },
    },
    methods: {
        ...mapActions({
            warehousesStore: "WAREHOUSES_STORE",
            warehouseUpdate: "WAREHOUSE_UPDATE",
        }),
        onSubmit() {
            if (this.operation === "store") {
                this.warehousesStore([this.warehouseModel]);
            } else if (this.operation === "update") {
                this.warehouseUpdate(this.warehouseModel);
            }
            this.$emit("end");
        },
        onReset() {
            this.$emit("cancel");
        },
    },
    data() {
        const warehouseModel = JSON.parse(JSON.stringify(this.warehouse));
        if (warehouseModel.creationDate === "") {
            warehouseModel.creationDate = new Date().toISOString().split("T")[0];
        }
        return {
            warehouseModel,
        };
    },
};
</script>

<style scoped lang="scss">
.warehouse-edit__wrapper::v-deep {
    @apply fixed top-0 left-0 z-10 h-full w-full flex flex-row items-center justify-center;
    background-color: $background-wrapper-edit-color;

    .warehouse-edit {
        @apply border border-solid;
        border-color: $border-warehouse-card-color;
    }

    .warehouse-edit__card-header {
        background-color: $background-warehouse-card-header-color;
    }
}
</style>
